module.exports = "/assets/0c30017c0ca1ed68054180deb6b73482.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/U2.png
// module id = 2995
// module chunks = 0